<template>
  <notifications position="top right" :pauseOnHover="true">
    <template #body="props">
      <div class="vue-notification-wrapper">
        <div class="vue-notification-template vue-notification" :class="props.item.type">
          <div class="notification-title">
            {{ props.item.title }}
          </div>

          <div
              class="notification-content"
              v-html="props.item.text"
          ></div>

          <div v-if="roleAdmin.includes(this.$user.role) && props.item.data?.details" class="mt-2">
            <div class="d-flex align-items-center g-2">
              <i v-if="isOpen(props.item)" class="ki-duotone ki-up-square text-white">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <i v-else class="ki-duotone ki-down-square text-white">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
              <a
                  class="ms-1 cursor-pointer text-sm text-white hover:underline"
                  @click="toggleDetails(props.item)"
              >
                {{ isOpen(props.item) ? 'Скрыть детали' : 'Показать детали' }}
              </a>
            </div>

            <transition name="fade">
              <pre
                  v-if="isOpen(props.item)"
                  class="mt-1 text-xs bg-gray-100 p-2 rounded max-h-48 overflow-auto text-black"
              >{{ props.item.data?.details }}</pre>
            </transition>
          </div>
        </div>
      </div>
    </template>
  </notifications>
</template>

<script>
import permissions from '@/helpers/permissions';
export default {
  name: 'CustomNotification',
  components: {permissions},
  data() {
    return {
      openItems: new Set()
    }
  },
  computed: {
    roleAdmin() {
      return permissions.admin()
    },
  },
  methods: {
    toggleDetails(item) {
      if (this.openItems.has(item.id)) {
        this.openItems.delete(item.id)
      } else {
        this.openItems.add(item.id)
      }
    },
    isOpen(item) {
      return this.openItems.has(item.id)
    },
  }
}
</script>

<style scoped>
.text-sm {
  font-size: 0.875rem;   /* 14px */
  line-height: 1.25rem;  /* 20px */
}

.text-xs {
  font-size: 0.75rem;    /* 12px */
  line-height: 1rem;     /* 16px */
}
</style>
